import { Placement, PopoverOffset, PopoverPositioningStrategy } from '@one/web-components';
import { useId } from 'commons/hooks/use-id/use-id.hook';
import React, { PropsWithChildren } from 'react';
import { TooltipedElmWrapper, TooltipElm } from './tooltiped-element.style';

export interface TooltipedTextComponentProps {
    tooltipText: string | React.ReactNode;
    className?: string;
    anchorId?: string;
    tooltipAnchorClassname?: string;
    strategy?: PopoverPositioningStrategy;
    placement?: Placement;
    hideTooltip?: boolean;
    dataTestId?: string;
    offset?: PopoverOffset;
}

const defaultVerticalOffset = 8;
const defaultHorizontalOffset = 0;

export const TooltipedElementComponent: React.FC<PropsWithChildren<TooltipedTextComponentProps>> = (props) => {
    const {
        tooltipText,
        tooltipAnchorClassname,
        hideTooltip = false,
        className = '',
        strategy = 'fixed',
        placement = 'top',
        children,
        dataTestId,
        anchorId,
        offset = [defaultHorizontalOffset, defaultVerticalOffset],
    } = props;

    const fallbackId = useId();
    const tooltipAnchorId = anchorId ?? fallbackId;

    return (
        <div style={{ display: 'flex' }} className={className} data-testid={dataTestId}>
            <TooltipedElmWrapper id={tooltipAnchorId} className={tooltipAnchorClassname} style={{ width: '100%' }}>
                {children}
            </TooltipedElmWrapper>
            {!hideTooltip && (
                <TooltipElm anchor={tooltipAnchorId} strategy={strategy} placement={placement} offset={offset}>
                    {tooltipText}
                </TooltipElm>
            )}
        </div>
    );
};
